import { render, staticRenderFns } from "./ci-messages-table.vue?vue&type=template&id=3a47561c&scoped=true&"
import script from "./ci-messages-table.vue?vue&type=script&lang=js&"
export * from "./ci-messages-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a47561c",
  null
  
)

export default component.exports